import { Component, EventEmitter, OnChanges, Input, OnInit, Output, SimpleChanges } from '@angular/core';

import { AppComponent } from '../../app.component';
import { HubService } from '../../services/hub.service';
import { EcmsEntry } from '../../types/ecms-entry'
import { HeatingSystem } from '../../types/heating-system';
import { LeadStatus } from '../../types/lead-status';
import { Installer } from '../../types/installer';
import { LeadDetails } from '../../types/leads';

export interface Dropdown {
    type: string;
    id: string;
}

export interface TrueFalse {
    type: boolean;
    name: string;
}

@Component({
    selector: 'mastersheet-upload',
    templateUrl: './mastersheet-update.component.html',
    styleUrls: ['./mastersheet-update.component.css'],
    providers: [HubService],
})

export class MastersheetUploadComponent implements OnInit {
    public failFlag: boolean;

    leadStatusList = <LeadStatus[]>[];
    heatingSystemList = <HeatingSystem[]>[];
    installerList = <Installer[]>[];

    errorMessage: string;

    updateList = new LeadDetails

    fuels: Dropdown[] = [
        { type: 'Oil', id: 'oil' },
        { type: 'Gas', id: 'gas' },
        { type: 'Other', id: 'other' }
    ];

    source: Dropdown[] = [
        { type: 'facebook', id: 'Facebook' },
        { type: 'mailchimp', id: 'MailChimp' },
        { type: 'website', id: 'Website' },
        { type: 'manual', id: 'Manual' },
        { type: 'other', id: 'Other' }
    ];

    truefalse: TrueFalse[] = [
        { type: true, name: "true" },
        { type: false, name: "false" }
    ];

    isDisabled: boolean;
    isUploading: boolean;

    @Output() open_close = new EventEmitter<boolean>();
    @Input() inUidList: string;

    constructor(
        private hubService: HubService,
    ) {
    }

    ngOnInit(): void {
        if (!AppComponent.IsLoggedIn()) { return; }
        this.isDisabled = false;
        this.isUploading = false
        this.failFlag = false;
        this.updateList.uids = this.inUidList.toString();

        this.hubService.getLookupTable('lead_status').subscribe(
            lookup_values => this.leadStatusList = <LeadStatus[]>lookup_values,
            error => this.errorMessage = <any>error,
        );
        this.hubService.getLookupTable('heating_system').subscribe(
            lookup_values => this.heatingSystemList = <HeatingSystem[]>lookup_values,
            error => this.errorMessage = <any>error,
        );
        this.hubService.getLookupTable('installers').subscribe(
            lookup_values => this.installerList = <Installer[]>lookup_values,
            error => this.errorMessage = <any>error,
          );
    }

    sendFlag() {
        this.open_close.emit(false);
    }

    upload() {
        var uids = this.updateList.uids.split(",");

        var leadsDetails = <LeadDetails[]>[];
        for(var i = 0; i < uids.length; i++){
            var tempLead = new LeadDetails;
            tempLead.uid = +uids[i];
            tempLead.duplicate = this.updateList.duplicate;
            tempLead.fuel_type = this.updateList.fuel_type;
            tempLead.approved = this.updateList.approved;
            tempLead.source = this.updateList.source;
            tempLead.have_wifi =this.updateList.have_wifi;
            tempLead.built_before_2007 =this.updateList.built_before_2007;
            tempLead.previous_grant =this.updateList.previous_grant;
            tempLead.use_time_clock =this.updateList.use_time_clock;
            tempLead.dead_lead = this.updateList.dead_lead;
            tempLead.lead_status_id = +this.updateList.lead_status_id;
            tempLead.heating_system_id = +this.updateList.heating_system_id;
            tempLead.removed = this.updateList.removed;
            tempLead.installer_name = this.updateList.installer_name;
            tempLead.installer_company_name = this.updateList.installer_company_name;
            tempLead.installation_batch = +this.updateList.installation_batch;
            tempLead.ber = this.updateList.ber;
            if (this.updateList.handed_to_installer != undefined) {
                tempLead.handed_to_installer = new Date(this.updateList.handed_to_installer);
              }
            leadsDetails.push(tempLead);
        }
        
        this.hubService.writeLeadsDetails(leadsDetails)
            .subscribe(
                data => {console.log(data.status),
                this.sendFlag();
            },
                error => this.errorMessage = <any>error,
        );
    
    }

    cancel() {
        this.sendFlag();
    }
}
